// User model 
export default class Organization {
    constructor(id, facility_id){
        this.id = id
        this.facility_id = facility_id
    }
}